import React, { useMemo } from 'react';
import { LookupSelect, type LookupSelectProps } from './LookupSelect';
import { labelNameOnly, type LookupRecord } from './lookupHelpers';
import { useEndpointLookupOptions } from './useLookupOptions';

const ENDPOINT = '/ports?page=1&limit=2000';

function keepIdsKey(includeIds: LookupSelectProps['includeIds']): string {
  return (includeIds ?? [])
    .map((id: string | number | null | undefined) => (id == null || id === '' ? '' : String(id)))
    .filter(Boolean)
    .join(',');
}

function labelPort(item: LookupRecord): string {
  const name = labelNameOnly(item);
  const code = String(item.code || '').trim();
  return code ? `${name} (${code})` : name;
}

/** Active ports, ordered by sortOrder then name. */
export function PortSelect({ includeIds, ...props }: LookupSelectProps) {
  const keepKey = keepIdsKey(includeIds);
  const keepIds = useMemo(() => (keepKey ? keepKey.split(',') : undefined), [keepKey]);
  const { options, isLoading } = useEndpointLookupOptions({
    endpoint: ENDPOINT,
    getLabel: labelPort,
    keepIds,
  });
  return (
    <LookupSelect
      {...props}
      includeIds={includeIds}
      options={options}
      isLoading={isLoading}
      placeholder={props.placeholder ?? 'Select port…'}
      searchPlaceholder={props.searchPlaceholder ?? 'Search ports…'}
    />
  );
}

export default PortSelect;
